import React from "react";
import { LayoutProviderProps, LayoutState } from "./types";
import { LayoutContext } from "./context";
import { DEFAULT_SIDEBAR_SIZE, DEFAULT_TEAMS_SIDEBAR_SIZE } from "@webV2/providers/LayoutProvider/defines";
import { useCurrentPath } from "@webV2/helpers/router/useCurrentPath";
import { DEFAULT_MAIN_MENU_ITEMS } from "@webV2/defines/nav-items";
import { IResource } from "@gettactic/api";
import { useAuthenticated } from "@gettactic/hooks";
import useTeamsApp from '@/hooks/useTeamsApp';

export const LayoutProvider: React.FC<
  React.PropsWithChildren<LayoutProviderProps>
> = ({ children }) => {
  const currentPath = useCurrentPath();

  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const navSections = React.useMemo(() => {
    return DEFAULT_MAIN_MENU_ITEMS.map((item) => ({
      ...item,
      active: `${currentPath}/`.startsWith(`${item.url}/`)
    }));
  }, [currentPath, authenticatedUser?.permissions]);

  const [selectedFloor, setSelectedFloor] = React.useState<IResource | null>(
    null
  );

  let sidebarSize = DEFAULT_SIDEBAR_SIZE;
  const teamsApp = useTeamsApp();
  if (teamsApp) {
    sidebarSize = DEFAULT_TEAMS_SIDEBAR_SIZE;
  }

  // const slug = location.hostname.split('.')[0];
  // const { setBrand } = useTheme();
  // useEffect(() => {
  //   setBrand(slug);
  // }, [slug]);

  const value: LayoutState = {
    sidebarSize,
    navSections,
    setSelectedFloor,
    selectedFloor
  };

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
